<script setup>
// §8.1 sub-nav item — lives inside SideNavGroup. Sub-nav active label uses
// accent-text (AA-safe on-light brass, §3.2). 12.5px Inter (§5).
defineProps({
	active: { type: Boolean, default: false },
	as: { type: String, default: 'button' }, // button | a | router-link
	to: { type: String, default: null },
})
</script>

<template>
	<!-- <button class="subnav" :class="{ on: active }" :aria-current="active ? 'page' : undefined" type="button">
		<slot />
	</button> -->
	
	<component
		:is="as" 
		:to="to" 
		:href="as === 'a' ? to : undefined" 
		class="subnav" 
		:class="{ on: active }"
		:aria-current="active ? 'page' : undefined" 
		:type="as === 'button' ? 'button' : undefined"
	>
		<span class="ic">
			<slot name="icon" />
		</span>
		<span class="lbl">
			<slot />
		</span>
		<!-- <span class="ic">
			<slot name="icon" />
		</span> -->
		<span v-if="$slots.trailing" class="tr">
			<slot name="trailing" />
		</span>
	</component>
</template>

<style scoped>
.subnav
{
	display: flex;
	align-items: center;
	padding: 7px 12px;
	font-size: 12.5px;
	font-weight: 500;
	color: var(--text-2);
	min-height: var(--target-min);
	background: none;
	border: 0;
	cursor: pointer;
	text-align: left;
	border-radius: var(--r-sm);
	width: 100%;
	text-decoration: none;
}

.lbl
{
	flex: 1;
}

/* The optional `#trailing` slot (a count badge, say), pushed to the right edge like SideNavItem's. */
.tr
{
	display: inline-flex;
	flex: none;
}

.subnav:hover
{
	background: var(--surface-sunken);
	color: var(--text);
}

.subnav.on
{
	color: var(--accent-text);
	font-weight: 600;
}
</style>
